/**
 * Jetons produits par le lexer du simulateur `Time.deltaTime`.
 *
 * Positions : `line` et `column` sont 1-based, comme dans la console d'erreurs
 * de la page d'exercice (A11) et comme dans les messages du vrai compilateur C#.
 */

export type TokenKind =
  | 'word' // identifiant OU mot-clé (le parseur décide via `value`)
  | 'number'
  | 'string'
  | 'char'
  | 'punct'
  | 'eof';

/** `5` → int, `5f` → float, `5.0` / `5d` → double (erreur pédagogique CS0664). */
export type NumberKind = 'int' | 'float' | 'double';

export interface Token {
  kind: TokenKind;
  /** Texte tel qu'écrit (pour `string` : contenu sans les guillemets, échappements résolus). */
  value: string;
  line: number;
  column: number;
  numberKind?: NumberKind;
  numberValue?: number;
}

/** Mots réservés C# que le parseur reconnaît (les autres `word` sont des identifiants). */
export const KEYWORDS: ReadonlySet<string> = new Set([
  'using', 'namespace', 'class', 'struct', 'interface', 'enum',
  'public', 'private', 'protected', 'internal', 'static', 'const', 'readonly',
  'override', 'virtual', 'abstract', 'sealed', 'partial',
  'void', 'var', 'new', 'this', 'base', 'null', 'true', 'false',
  'if', 'else', 'for', 'foreach', 'while', 'do', 'switch', 'case', 'default',
  'break', 'continue', 'return', 'yield', 'goto', 'try', 'catch', 'finally', 'throw',
  'in', 'out', 'ref', 'is', 'as', 'typeof', 'lock', 'checked', 'unchecked',
]);

/** Ponctuation reconnue, de la plus longue à la plus courte (le lexer teste dans cet ordre). */
export const PUNCTUATION: readonly string[] = [
  '<<=', '>>=', '=>', '??', '::',
  '++', '--', '+=', '-=', '*=', '/=', '%=', '==', '!=', '<=', '>=', '&&', '||',
  '+', '-', '*', '/', '%', '=', '<', '>', '!', '.', ',', ';', '(', ')', '{', '}', '[', ']',
  ':', '?', '&', '|', '^', '~', '#', '$', '@',
];
